import React from "react";

import { IActiveLearningIssue } from "../../../../../state";
import SaveAnswerButton from "../../../../../atoms/ActiveLearning/SaveAnswerButton";
import Issue1 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson11/Material/Issue1";
import Issue2 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson11/Material/Issue2";
import Issue3 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson11/Material/Issue3";
import Issue4 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson11/Material/Issue4";
import styles from "../../ActiveLearningLesson.module.scss";

type Lesson11MaterialProps = {
  findIssue?: (no: number) => IActiveLearningIssue | undefined;
};

export const Lesson11Material = (props: Lesson11MaterialProps) => {
  return (
    <>
      <div className={styles.section}>
        <Issue1 issue={props.findIssue && props.findIssue(1)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
      <div className={styles.section}>
        <Issue2 issue={props.findIssue && props.findIssue(2)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
      <div className={styles.section}>
        <Issue3 issue={props.findIssue && props.findIssue(3)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
      <div className={styles.section}>
        <Issue4 issue={props.findIssue && props.findIssue(4)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
    </>
  );
};
export default Lesson11Material;
